const axios = require('axios')

export default {
    async getData(url, params) {
        window.console.log('GET ' + url)
        let res
        if (params)
            res = await axios.get(url, params)
        else
            res = await axios.get(url)

        console.log("Response: " + res.status)
        console.log(res.data)

        return res.data;
    },

    async deleteData(url, params) {
        window.console.log('DELETE ' + url)
        let res
        if (params)
            res = await axios.delete(url, params)
        else
            res = await axios.delete(url)

        console.log("Response: " + res.status)
        console.log(res.data)

        return res;
    },

    async postData(url, body, params) {
        window.console.log('POST ' + url)
        window.console.log(body)
        let res;
        if (params)
            res = await axios.post(url, body, params)
        else
            res = await axios.post(url, body)

        console.log("Response: " + res.status)
        console.log(res.data)

        return res.data;
    },

    async putData(url, body, params) {
        window.console.log(' PUT ' + url)
        window.console.log(body);
        let res;
        if (params)
            res = await axios.put(url, body, params)
        else
            res = await axios.put(url, body)

        console.log("Response: " + res.status)
        console.log(res.data)

        return res.data;
    },

    logout() {
        delete axios.defaults.headers.common['Authorization'];
        delete window.localStorage['access_token'];
        delete window.localStorage['refresh_token'];
        delete window.localStorage['expires_in'];
        delete window.localStorage['logged_at'];
        delete window.localStorage['user'];
        console.log("logout");
    },
}